<c-footer position="fixed">
  <div class="container-footer">
    <div class="row">
      <div class="col-auto">
        <span>CEXVEG &copy; {{ copyrightYear }} - Versión: {{version}} {{environment}}</span>
      </div>
      <div class="col-auto">
        <span>
          <a href="https://www.mapa.gob.es/es/" title="Ministerio de Agricultura, Pesca y Alimentación" class="cexveg" target="_blank">MAPA</a> - Ministerio de Agricultura,
          Pesca y Alimentación.</span>
      </div>
    </div>
  </div>
</c-footer>
